<span class="contents" [innerHTML]="html()"></span>
